/**
 * How many things wait behind a nav pill. A number while the sidebar is open, a dot on the icon
 * once it collapses, nothing at zero. Same fill as the bell badge, so both read as one signal.
 */
export function NavCountBadge({ count, label }: { count: number; label: string }) {
  if (count <= 0) return null;

  return (
    <>
      <span
        role="status"
        aria-label={label}
        className="ml-auto flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1.5 text-[11px] font-semibold tabular-nums leading-none text-primary-foreground group-data-[collapsible=icon]:hidden"
      >
        {count > 99 ? "99+" : count}
      </span>
      <span
        aria-hidden
        className="absolute right-1 top-1 hidden size-2 rounded-full bg-primary ring-2 ring-sidebar group-data-[collapsible=icon]:block"
      />
    </>
  );
}
